// Copyright (c) 2025 Deere & Company

import './dealer-recommendation-modal-body.scss';
import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

class DealerRecommendationModalBody extends Component {

    constructor(props) {

        super(props);
        this.handleInternalDeereCommentsChange = this.handleInternalDeereCommentsChange.bind(this);
        this.handleConfirmation = this.handleConfirmation.bind(this);

    }

    state = {
        buttonDisabled: false,
        dealerRecommendationComments: ''
    };

    handleInternalDeereCommentsChange(event) {

        this.setState({dealerRecommendationComments: event.target.value});

    }

    handleConfirmation() {

        this.setState({buttonDisabled: true});
        this.props.onConfirmation(this.props.dealerRecommendationModalAction, this.state.dealerRecommendationComments);

    }

    render() {

        return (
            <section className='dealer-recommendation-modal-body'>
                <div className='row'>
                    <span className='data-label internal-deere-comments'>
                        <FormattedMessage id='REASON_FOR_CHANGE'/>
                    </span>
                    <textarea
                        maxLength='120'
                        onChange={this.handleInternalDeereCommentsChange}
                    >
                    </textarea>
                </div>
                <div className='button'>
                    <button
                        className='primary'
                        disabled={this.state.buttonDisabled}
                        onClick={this.handleConfirmation}
                    >
                        <FormattedMessage id='CONFIRM'/>
                    </button>
                </div>
            </section>
        );

    }
}

DealerRecommendationModalBody.displayName = 'DealerRecommendationModalBody';
DealerRecommendationModalBody.propTypes = {
    dealerRecommendationModalAction: PropTypes.string.isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default DealerRecommendationModalBody;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-modal-body.js